export const originalQueryKeyFactory: {
  originalQueryKey: string;
  set: Function;
  get: Function;
} = {
  originalQueryKey: '',
  set(originalQueryKey: string = '') {
    this.originalQueryKey = originalQueryKey;
    return this;
  },
  get() {
    return this.originalQueryKey;
  },
};
